/**
 * Responsive Tables
 * @author Rhys Lloyd
 */

// Utilities
import debug from "debug";
const MODULE_NAME = 'responsive-tables';
const log = debug(MODULE_NAME);
// Constants
const RESPONSIVE_TABLE_SELECTOR = 'table[data-responsive-table]';
const RESPONSIVE_TABLE_CELL_HEADING = 'data-responsive-table-cell';
const RESPONSIVE_TABLE_CLASS = 'responsive-table';

/**
 * Modifies the provided table (via `this`) ready for responsive use.
 * @this {jQuery} - Table to process
 */
function processTable () {
	const $table = $(this);
	const headings = [];

	$table.addClass(RESPONSIVE_TABLE_CLASS);

	// Get headings
	const $tableHeadings = $table.find('thead tr:first-child th');
	$tableHeadings.each(function () {
		headings.push($(this).text());
	});


	// Process cells
	const $tableRows = $table.find('tbody tr');
	let headingCount = $tableHeadings.length;

	while (headingCount--) {
		let $cells = $tableRows.find(`td:eq(${headingCount})`);
		$cells
			.addClass(`${RESPONSIVE_TABLE_CLASS}__cell`)
			.attr(RESPONSIVE_TABLE_CELL_HEADING, headings[headingCount])
			.wrapInner(`<div class="${RESPONSIVE_TABLE_CLASS}__cell-value" />`);
	}

	log('table processed', $table);
}

/**
 * Run plugin
 */
export function exec () {
	log('Running...');

	// Find tables
	let $tablesList = $(RESPONSIVE_TABLE_SELECTOR);

	// Process each table
	$tablesList.each(processTable);
}


export {exec as default};



// WEBPACK FOOTER //
// ./project/client/src/core/modules/tables/responsive-tables.js